/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * The schema of the Draft.
 */
export interface Draft {
    /** The JSON-LD vocabularies used in the draft. */
    jsonLdVocabs?: string[];
    /** A list of linked credential references. */
    linkedCredentialRefs?: Truvity.LinkedRef[];
    /** A list of linked draft references. */
    linkedDraftRefs?: Truvity.LinkedResourceRef[];
    /** Metadata about the draft. */
    meta?: Truvity.DraftMeta;
    /** The URL to meta schema. */
    metaSchema: string;
    /** A list of credential types. [Terminology](https://www.w3.org/TR/vc-data-model/#dfn-type). */
    type: string[];
    /** The values of the draft. */
    values?: Truvity.CredentialClaimValues;
    /** The VCDM JSON schemas used in the draft. */
    vcdmJsonSchemas?: string[];
}
